module.exports = __webpack_public_path__ + "img/folios--icon.b8a2c8b8.svg";